import {Color} from 'src/modules/downloads/cells/styles';

export const DEFAULT_FONT_NAME = 'Arial';

enum FontSize {
    SMALL = 8,
    LARGE = 16,
}

export const defaultFont = {
    name: DEFAULT_FONT_NAME,
    size: FontSize.SMALL,
};

export const defaultSheetTitleFont = {
    name: DEFAULT_FONT_NAME,
    size: FontSize.LARGE,
    bold: true,
};

export const defaultTableHeaderFont = {
    ...defaultFont,
    color: {argb: Color.WHITE},
    bold: true,
};

export const defaultLinkFont = {
    name: DEFAULT_FONT_NAME,
    size: FontSize.SMALL,
    color: {argb: Color.BLUE},
    underline: true,
};

export const defaultCriteriaValueFont = {
    ...defaultFont,
    color: {argb: Color.RED},
};

export const defaultCriteriaKeyFont = {
    ...defaultCriteriaValueFont,
    bold: true,
};
